module.exports = __webpack_public_path__ + "static/media/contact_04.9d82a29a.jpg";